import { usePageCRUDActions } from '@mm/state/actions/PageCRUDActions';
import { usePromoterCRUDActions } from '@mm/state/actions/PromoterCRUDActions';
import { PageKind } from '@mm/state/model/PageModel';
import {
  LinkTypes,
  optinSettingsDefault,
  PromoterModel,
} from '@mm/state/model/PromoterModel';
import useRouter from 'use-react-router';
import { BotBuilderRoutes } from '../../../../routes/bot-builder-routes';

export const useCreatePromoter = () => {
  const {
    history,
    match: {
      params: { chatbotId },
    },
  } = useRouter<{ chatbotId: string }>();
  const botId = Number(chatbotId);
  const pageCURDActions = usePageCRUDActions();
  const promoterCRUDActions = usePromoterCRUDActions();

  const createPromoter = async (kind: LinkTypes) => {
    const chatStarterKind =
      kind &&
      [
        'link',
        'optin',
        'checkbox',
        'send_to_messenger',
        'instagram_welcomer',
      ].includes(kind)
        ? kind
        : undefined;

    const dialogueResponse = await pageCURDActions.create({
      botId,
      name: 'Start',
      kind: PageKind.StartBot,
      chatStarterKind,
    });

    const {
      page: { id: pageId },
    } = dialogueResponse;

    const newPromoter: PromoterModel = {
      description: 'Default description',
      botId,
      type: kind,
      pageId,
      active: false,
    };

    if (kind === 'optin') {
      newPromoter.optinSettings = optinSettingsDefault;
    }

    const createdPromoter = await promoterCRUDActions.create(newPromoter);

    if (createdPromoter.id) {
      const opts = {
        chatbotId: Number(chatbotId),
        dialogueId: pageId,
        promoterId: createdPromoter.id,
      };

      switch (kind) {
        case 'link':
          return history.push(BotBuilderRoutes.shareLinkEdit.getLink(opts));
        case 'send_to_messenger':
          return history.push(
            BotBuilderRoutes.sendToMessengerEdit.getLink(opts),
          );
        case 'checkbox':
          return history.push(
            BotBuilderRoutes.checkboxPluginEdit.getLink(opts),
          );
        case 'optin':
          return history.push(BotBuilderRoutes.leadPopupsEdit.getLink(opts));
        case 'instagram_welcomer':
          return history.push(
            BotBuilderRoutes.instagramWelcomerEdit.getLink(opts),
          );
        case 'instagram_story_mention':
          return history.push(
            BotBuilderRoutes.instagramStoryMentionEdit.getLink(opts),
          );
        case 'instagram_story_reaction':
          return history.push(
            BotBuilderRoutes.instagramStoryReactionEdit.getLink(opts),
          );
        case 'instagram_comment_guard':
          return history.push(
            BotBuilderRoutes.instagramCommentGuardEdit.getLink(opts),
          );
        case 'instagram_live_comment_guard':
          return history.push(BotBuilderRoutes.instagramLiveEdit.getLink(opts));
        default:
          throw new Error('Found unknown promoter type');
      }
    }
  };

  return { createPromoter };
};
